<div
  [attr.data-automation]="config.dataAutomation"
  class="mb-3 row form-group"
  [ngClass]="{ 'has-feedback': showValidation, 'ziro-forms-error': validationState === ValStates.INVALID }"
>
  <label [class]="'col-form-label col-3 ziro-forms-label text-lg-end'" [attr.for]="config.dataAutomation + '-input'">
    <span [innerHTML]="getLabel() | escapeHtml"></span>
  </label>
  <div class="align-items-center col-3" data-automation="pin-reset-input">
    <div [attr.data-automation]="config.dataAutomation + '-input'">
      <div class="col">
        <div class="d-flex">
          <div class="input-group">
            <input
              class="form-control input-text-start"
              [disabled]="isPending"
              [type]="inputType"
              [attr.id]="config.dataAutomation + '-input'"
              #ngModelDir="ngModel"
              (ngModelChange)="updateStateAndSelf($event, ngModelDir)"
              [(ngModel)]="fieldData"
              [placeholder]="placeholder | translate"
              data-automation="ziro-text-input"
              [autocomplete]="'new-password'"
            />
            <ziro-button
              [dataAutomation]="'pin-reset-confirm-button'"
              (clicked)="submit(fieldId())"
              [cssClass]="'input-btn-end'"
              [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
              [isPending]="isPending"
              [iconPending]="ziroIcons.SAVING"
              [icon]="ziroIcons.REFRESH"
              [isDisabled]="!fieldData || validationState === ValStates.INVALID || isPending"
            ></ziro-button>
          </div>
        </div>
        <div class="ziro-forms-feedback-area">
          <div
            class="ziro-forms-validation-message"
            data-automation="ziro-forms-validation-message"
            [hidden]="!showValidation"
          >
            {{ validationMessage?.content | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
